const themes = [
  {
    key: "default",
    color: "#F847CA",
    type: 'light',
    img_cover: 'cover-default.webp',
  },
  {
    key: "hotsale",
    color: "#F847CA",
    type: 'light',
    date_min: "2024-05-13 00:00:00",
    date_max: "2024-05-20 23:59:59",
    img_cover: 'cover-hotsale.webp',
    img_banner: 'banner-hotsale.webp',
  },
  {
    key: "halloween",
    color: "#F847CA",
    type: 'dark',
    date_min: "2024-10-24 00:00:00",
    date_max: "2024-10-31 23:59:59",
    img_cover: 'cover-halloween.webp',
    img_banner: 'banner-halloween.webp',
    img_banner_url: 'https://www.instagram.com/jipink.ar',
  },
  {
    key: "cyberweek",
    color: "#F847CA",
    type: 'light',
    date_min: "2023-11-06 00:00:00",
    date_max: "2023-11-13 23:59:59",
    img_cover: 'cover-cyberweek.webp',
    img_banner: 'banner-cyberweek.webp',
  },
  {
    key: "christmas",
    color: "#F847CA",
    type: 'light',
    date_min: "2024-12-18 00:00:00",
    date_max: "2024-12-25 23:59:59",
    img_cover: 'cover-christmas.webp',
    img_banner: 'banner-christmas.webp',
  },
]

function load() {
  const now = new Date()
  const theme = themes.find(t =>
    t.date_min != null &&
    t.date_max != null &&
    now > new Date(t.date_min) &&
    now < new Date(t.date_max))
  if (theme != null)
    return theme
  return themes[0]
}

const theme = load()

export default theme